import { render, staticRenderFns } from "./annexlist.vue?vue&type=template&id=be6863a0&scoped=true"
import script from "./annexlist.vue?vue&type=script&lang=js"
export * from "./annexlist.vue?vue&type=script&lang=js"
import style0 from "./annexlist.vue?vue&type=style&index=0&id=be6863a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6863a0",
  null
  
)

export default component.exports